import { Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import PropTypes from 'prop-types';

export default function JobListIntegration({ orgId }) {
  // states
  const [isCopied, setIsCopied] = useState(false);

  // variables
  const code = `<iframe src="https://apply.hireintel.app/organization/${orgId}?embed=true" width="100%" height="500px" frameborder="0"></iframe>`;

  return (
    <Stack
      bgcolor="background.primaryWhite1"
      border={theme => `1px solid ${theme.palette.border.primaryBlack3}`}
    >
      <Stack
        px="20px"
        py="23px"
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        sx={{
          borderBottom: theme =>
            `1px solid ${theme.palette.border.primaryBlack3}`,
        }}
      >
        <Stack spacing="10px">
          <Typography variant="h4">Job list integration</Typography>
          <Typography variant="input" color="content.primaryBlack3">
            Copy code, use it in your career pages to show your job lists{' '}
          </Typography>
        </Stack>
        <Button
          startIcon={<Iconify icon="tabler:copy" />}
          variant="contained"
          sx={{
            bgcolor: theme =>
              isCopied
                ? theme.palette.background.primaryAccent1
                : theme.palette.background.primaryBlack1,
          }}
          onClick={() => {
            navigator.clipboard.writeText(code);
            setIsCopied(true);
            setTimeout(() => {
              setIsCopied(false);
            }, 2000);
          }}
        >
          {isCopied ? 'Copied' : 'Copy code'}
        </Button>
      </Stack>
      <Stack px="20px" py="20px">
        <Stack
          px="20px"
          py="20px"
          bgcolor="#0d0d0d"
          color="#ffffff"
          borderRadius="9px"
        >
          <Typography color="#ffffff" fontSize={16} fontWeight={400}>
            {code}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

JobListIntegration.propTypes = {
  orgId: PropTypes.string.isRequired,
};
